import { ComponentPropsWithoutRef } from 'react';

export default function WarningBold(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg {...props} viewBox="0 0 17.7 16">
      <g stroke="currentColor">
        <path
          d="m7.15 1.96-5.89 10.1c-0.766 1.31 0.191 2.95 1.72 2.95h11.8c1.53 0 2.49-1.64 1.72-2.95l-5.89-10.1c-0.766-1.31-2.68-1.31-3.45 0z"
          strokeWidth="2"
        />
        <path
          d="m9.34 4.87v3.04c0 0.16-0.00355 0.316-0.0106 0.468s-0.016 0.306-0.0266 0.46l-0.018 0.234-0.0219 0.239c-0.016 0.161-0.0346 0.334-0.0558 0.519h-0.638l-0.039-0.353-0.0388-0.405-0.018-0.234c-0.0106-0.154-0.0195-0.308-0.0266-0.46-0.0071-0.152-0.0106-0.308-0.0106-0.468v-3.04zm-1.13 7.04c0-0.0922 0.0168-0.179 0.0505-0.261 0.0337-0.0816 0.0807-0.152 0.141-0.213 0.0603-0.0603 0.13-0.108 0.21-0.144 0.0798-0.0354 0.168-0.0532 0.263-0.0532 0.0922 0 0.178 0.0177 0.258 0.0532 0.0798 0.0355 0.15 0.0833 0.21 0.144 0.0603 0.0603 0.108 0.131 0.144 0.213 0.0355 0.0815 0.0532 0.168 0.0532 0.261 0 0.0958-0.0177 0.184-0.0532 0.263s-0.0833 0.15-0.144 0.21c-0.0603 0.0603-0.13 0.107-0.21 0.141-0.0798 0.0336-0.166 0.0505-0.258 0.0505-0.0958 0-0.184-0.0169-0.263-0.0505-0.0798-0.0337-0.15-0.0807-0.21-0.141-0.0603-0.0603-0.107-0.13-0.141-0.21-0.0337-0.0798-0.0505-0.168-0.0505-0.263z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}
